{
  "version": 1,
  "asset_id": "b2dec903-16ec-4079-bb71-68c9b6c4b3b5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b2dec903-16ec-4079-bb71-68c9b6c4b3b5/hiatal-type-3-second-en-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b2dec903-16ec-4079-bb71-68c9b6c4b3b5/hiatal-type-3-second-en-800.webp",
  "original_filename": "hiatal-type-3-second-en-800.webp",
  "size": 77952,
  "content_type": "image/webp",
  "created_at": "2026-09-26T23:53:33Z"
}
